import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';

function GDSNProcessManufacturerModal({ show, onHide, manufacturer, dataSource, onSubmit }) {
  const [selectedGlns, setSelectedGlns] = useState([]);
  const [lookbackDays, setLookbackDays] = useState(dataSource.lookback_days);

  useEffect(() => {
    // Set default GLN if available when manufacturer changes
    if (manufacturer?.manufacturer_glns && Object.keys(manufacturer.manufacturer_glns).length > 0) {
      setSelectedGlns([Object.keys(manufacturer.manufacturer_glns)[0]]);
    } else {
      setSelectedGlns([]);
    }
  }, [manufacturer]);

  const handleGlnChange = gln => {
    setSelectedGlns(prev => {
      if (prev.includes(gln)) {
        return prev.filter(g => g !== gln);
      } else {
        return [...prev, gln];
      }
    });
  };

  const handleSubmit = () => {
    onSubmit(manufacturer.id, selectedGlns, lookbackDays);
  };

  if (!manufacturer) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Process {manufacturer.name} Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Select GLNs</Form.Label>
            <div className="mt-2">
              {manufacturer.manufacturer_glns &&
                Object.entries(manufacturer.manufacturer_glns).map(([gln, subCompanyName]) => (
                  <Form.Check
                    type="checkbox"
                    key={gln}
                    id={`gln-${gln}`}
                    label={`${gln} ${subCompanyName ? `(${subCompanyName})` : ''}`}
                    name="glnOptions"
                    value={gln}
                    checked={selectedGlns.includes(gln)}
                    onChange={() => handleGlnChange(gln)}
                    className="mb-2"
                  />
                ))}
            </div>
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Lookback Days</Form.Label>
            <Form.Control
              type="number"
              value={lookbackDays}
              onChange={e => setLookbackDays(parseInt(e.target.value, 10))}
              min="1"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={selectedGlns.length === 0}>
          Process
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

GDSNProcessManufacturerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  manufacturer: PropTypes.object,
  dataSource: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default GDSNProcessManufacturerModal;
